/**
 * The trip type selecter uses tabs to toggle between one way trip, return trip and multitrip flights
 *
 */

import React from "react";
import { SxProps, Tab, Tabs, useTheme } from "@mui/material";
import {
  changeFlights,
  changeTripType,
  searchFormSelector,
  IFlight,
} from "redux/searchForm";
import { useSelector } from "react-redux";
import { UseAppDispatch } from "redux/store";
import { initialFlightObj } from "redux/filters/initialState";
import { useTranslations } from "hooks/useTranslations";
import {
  ITripType,
  deepCloneObject,
  pushToDataLayer,
} from "@thekilroygroup/shared-ui";

export default function TripTypeSelector() {
  const { flights, tripType } = useSelector(searchFormSelector);
  const dispatch = UseAppDispatch();
  const {
    translations: {
      search: { tripTypes },
    },
  } = useTranslations();

  const { breakpoints } = useTheme();
  const handleChange = (event: React.SyntheticEvent, value: ITripType) => {
    pushToDataLayer("Change ticket type", value);
    let nextFlights = [...flights];
    nextFlights.length = 1;
    const nextTripType: ITripType = value;

    if (nextTripType === "RETURN") {
      // When switching to return flight a new flight object must be made on index 1
      let returnFlight: IFlight = deepCloneObject({ ...initialFlightObj });
      returnFlight.departure = nextFlights[0].arrival;
      returnFlight.arrival = nextFlights[0].departure;
      if (flights.length >= 2) {
        returnFlight.departureDate = flights[1].departureDate;
      }
      nextFlights.push({ ...returnFlight });
    }
    dispatch(changeFlights(nextFlights));
    dispatch(changeTripType(value));
  };

  return (
    <>
      <Tabs
        value={tripType}
        onChange={handleChange}
        aria-label="tabs"
        sx={{
          minHeight: "initial",
          maxWidth: breakpoints.values.lg,
          width: 1,
          my: "auto",
          mx: 0,
        }}
      >
        <Tab sx={tabStyles} label={tripTypes.RETURN} value="RETURN" />
        <Tab sx={tabStyles} label={tripTypes.ONE_WAY} value="ONE_WAY" />
        <Tab sx={tabStyles} label={tripTypes.OPEN_JAW} value="MULTI_DEST" />
      </Tabs>
    </>
  );
}

const tabStyles: SxProps = {
  pt: 1.23,
  pb: 5 / 8,
  px: 0,
  minWidth: "initial",
  minHeight: "initial",
  mr: 3,
  textTransform: "initial",
  fontWeight: "500",
  "&:last-of-type": {
    mr: "0",
  },
  "&.Mui-selected": {
    fontWeight: "600",
  },
};
